export default "/images/vendor/flag-icons/flags/4x3/by.svg?4c57e6cbe13c574dcedecac31357bfc1";